// extracted by mini-css-extract-plugin
export var divider = "_18-0";
export var dividerText = "_18-1";